import FlightInfo from './FlightInfo';
import { i18n } from 'i18n';
import { h } from '@stencil/core';
import { DetailedFlightSegmentDto } from 'client/types';

export default function SegmentInfo({ segment }: { segment: DetailedFlightSegmentDto }) {
  return (
    <div class="segment-info">
      <span class="segment-info-wrapper">
        <FlightInfo datetime={segment.departureDatetime} city={segment.origin} />
        <span class="center-column-container">
          <span class="duration-info-container">
            <p class="duration-text">{i18n.t.flightDetailModal.duration}</p>
            <p class="duration-info">{segment.duration}</p>
          </span>
        </span>
        <FlightInfo datetime={segment.arrivalDatetime} city={segment.destination} />
      </span>
    </div>
  );
}
